export default {
	customer: 1,
	franchisee: 2
}